<template>
  <div class="lamp-content">
    <el-transfer
      filterable
      :data="allDevices"
      :titles="['未分配的屏幕', '已分配的屏幕']"
      :button-texts="['从列表删除', '添加到列表']"
      v-model="allocated"
      @change="dataChange"
    >
    </el-transfer>
    <br />
    <el-button type="primary" @click="cancel">返回</el-button>
  </div>
</template>
<script>
import screenApi from "@/api/message/screenList"
import programApi from "@/api/message/programList"
export default {
  name: "sendprogram",
  props: {
    sendData: {
      type: Object
    },
  },
  data() {
    return {
      allDevices: [],
      allocated: []
    }
  },
  methods: {

    dataChange(value, direction, movedKeys) {
      if (direction === "right") { // 分配
        programApi.programFen({
          type: 1,
          ids: movedKeys.toString(),
          program_id: this.sendData.id
        }).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("分配成功")
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else { // 取消分配
        programApi.programFen({
          type: 0,
          ids: movedKeys.toString(),
          program_id: 0
        }).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("取消分配成功")
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    getAllDevices() { // 获取所有屏幕
      screenApi.screenList({
        page: 1,
        pageSize: 2000
      }).then((res) => {
        if (res.data.code === 1000) {
          for (const device of res.data.data.list) {
            this.allDevices.push({
              key: device.id,
              label: device.name
            })
          }

          this.getAllocated()
        }
      })
    },
    getAllocated() { // 获取该节目单下的所有屏幕
      screenApi.screenList({
        program_id: this.sendData.id,
        page: 1,
        pageSize: 2000
      }).then((res) => {
        if (res.data.code === 1000) {
          for (const alodevice of res.data.data.list) {
            this.allocated.push(alodevice.id)
          }
        }
      })
    },
    cancel() {
      this.$emit('closeMethod')
    }
  },
  created() {
    this.getAllDevices()
  }
}
</script>
